import {Head} from '@aboutyou/head-elements';
import {useTranslation} from '@aboutyou/i18n';
import {useParams} from '@aboutyou/router';
import {FONT_SIZES, Text, tabletAndUpLinaria} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {StrictMode, useState} from 'react';
import {LegalReportForm} from './LegalReportForm/LegalReportForm';
import {LegalReportSuccessPage} from './LegalReportSuccessPage';

export const LegalReportPage: React.FC = () => {
  const {t} = useTranslation();
  const params = useParams<{productId: string}>();
  const [showSuccessPage, setShowSuccessPage] = useState(false);

  const handleOnSuccess = () => {
    setShowSuccessPage(true);
    window.scrollTo({top: 0});
  };

  return (
    <StrictMode>
      <Head>
        <title>{t('Legal report')}</title>
        <meta data-rh="true" content="noindex, nofollow" name="robots" />
      </Head>

      <Page>
        <Wrapper>
          {showSuccessPage ? (
            <LegalReportSuccessPage />
          ) : (
            <>
              <TitleWrapper>
                <Title as="h1" size="px32" weight="heavy">
                  {t('Legal report')}
                </Title>
                <Text weight="mediumBold">{t('* Required fields')}</Text>
              </TitleWrapper>
              <LegalReportForm
                productId={+params.productId}
                onSuccess={handleOnSuccess}
              />
            </>
          )}
        </Wrapper>
      </Page>
    </StrictMode>
  );
};

const Page = styled.div`
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 542px;
  margin-top: 10px;
  padding: 16px;

  ${tabletAndUpLinaria(`
    margin-top: 48px;
    padding: 0;
  `)}
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  ${tabletAndUpLinaria(`
    margin-bottom: 40px;
  `)}
`;

const Title = styled(Text)`
  font-size: ${FONT_SIZES.px24};
  margin: 0;

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px32};
  `)}
`;
